import { useAppSelector } from "@/lib/store";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { uuid } from "@/interfaces";

export default function TypingIndicator({ roomId }: { roomId: uuid }) {
    const meId = useAppSelector(s => s.auth.user?.id);
    const typingMap = useAppSelector(s => s.realtime.byRoom[roomId] ?? {});
    const users = useAppSelector(s => s.users);

    const others = Object.entries(typingMap)
        .filter(([uid, v]) => uid !== meId && v.typing)
        .map(([uid]) => users[uid]);

    if (!others.length) return null;

    if (others.length <= 3) {
        const names = others.map(u => u?.name || "Someone").join(", ");
        return <p className="text-xs italic text-muted-foreground px-2 py-2">{names} typing…</p>;
    }

    return (
        <div className="flex items-center space-x-1 px-2 py-2">
            {others.slice(0, 3).map(u => (
                <Avatar key={u.id} className="h-4 w-4">
                    {u.image && <AvatarImage src={u.image} />}
                    <AvatarFallback>{u.name.slice(0, 1)}</AvatarFallback>
                </Avatar>
            ))}
            <span className="text-xs italic ml-1">typing…</span>
        </div>
    );
}